import React, { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import CheckboxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const InitialRequestDelay = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Initial Request Delay"
				headingPath={['Dashboard', 'Framerate', 'Request Structure Data', 'Initial Request Delay']}
				description="Set the Request delay in ms for the first ad request"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ margin: '4rem 0 0 5rem', width: '90%' }}>
				<Grid item xs={3}>
					<CheckboxInput
						keyData={keyData + '.enabled'}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Delay (ms)"
						keyData={keyData + '.delayInMs'}
						inputType="number"
						editable={!!rawConfig[keyData + '.enabled']}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default InitialRequestDelay;
